// https://blog.thoughtram.io/angular/2015/04/09/developing-a-tabs-component-in-angular-2.html

export * from './tab/tab.component';
export * from './tabs/tabs.component';
